import React from "react";

const Text1 = () => {
  
React.useEffect(() => {
  // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
  document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
  , []);
  return(
    <>
      <p className="content-heading" id="top">
        Varmt Välkommen till <i>din</i>BiZ
      </p>

      <div className="content-text mt-4">       
        <p>
          <i>din</i>BiZ ger dig verktyget för att analysera, simulera, greppa och att 
          utveckla lönsamhetpotentialen hos din affär, både som startup och 
          etablerat företag.          
        </p>
        <ul>
          <li className="mt-2"> 
            <span className="strong">UtbudsMix</span> - Identifiera och prioritera dina lönsammaste 
            erbjudanden. Fokusera 80% av tillgängliga resurser där - och 20% på övrigt utbud.
          </li>
          <li className="mt-2"> 
            <span className="strong">Fasta Kostnader</span> - Slimma och trimma! Redan på idéstadiet kan 
            du få god uppfattning om vilka fasta kostnader verksamheten kommer att kräva och hur 
            de påverkar lönsamheten. <br/> <i>OBS - För realistisk lönekalkyl måste fasta kostnader anges!</i>
          </li>
          <li className="mt-2"> 
            <span className="strong">Åtgärder</span> (Road Map) för att nå ditt <span className="strong">Mål</span> 
            <p>
              <i>din</i>BiZ ger god koll på tid, pengar, prioritet, start/klart-datum med 
              mera och sortering på valfri kategori. 
            </p>
            <p className="mt-2 mb-0">
              Används exempelvis för
            </p>
            <ul>
              <li>Marknadsetablering/expansion</li>
              <li>Lönsamhetshöjande åtgärder</li>
              <li>Andra utvecklingsprojekt</li>
            </ul>
            <p className="mt-3">
              <i>OBS – åtgärdskostnader ackumuleras i Fasta Kostnader som sänker ditt löneuttag.</i>
            </p>
          </li>     
          <li> 
            <span className="strong">Lönekalkyl</span> - För precisare beräkning av ditt högsta möjliga 
            löneuttag per månad kan du själv kalibrera lönekalkylen efter individuell skattestatus.
          </li> 
        </ul>

        <p className="mt-4">
          Efter analysresultaten använts i verkligheten, vill du förmodligen 
          uppdatera <i>din</i>BiZ med aktuella data. Då kör du en ny analysrunda. Och så vidare ...                   
        </p>
        <p className="lead fw-bold text-muted mt-5">
          <span className="markedtext ps-3 pe-3 pt-1 pb-1 rounded"> Kom igång Direkt </span>          
        </p>
        <p>
          Se Flik: <span className="textdark fw-bold">Frågor & Svar </span> 
          samt Flik: <span className="textdark fw-bold">Så här gör du </span> <br/>
          Innan du kör seriöst: Se även Flik: <span className="textdark fw-bold">Förberedelser</span>
        </p>
        <p className="mt-5 w-75 text-muted fw-bold">
          <small><i>(Skulle din BiZ-simulering visa att affären inte blir lönsam nog – 
          kan du välja att tänka om din affärsidé från grunden och testa på nytt. 
          Alternativt kan du avstå från att förlora mer tid och pengar och istället ta 
          fram en ny mera lönsam affärsidé?)</i></small>
        </p>
        <p className="lead"> 
          Massa Lycka till med ditt affärsprojekt                   
        </p>
        <p>
          <small>Teamet bakom <i>din</i>BiZ</small> <br/>
          <small>Anders, Peter, Eduardo, Robin och Göran</small>                      
        </p>  
       
        
           
      </div>
    </>
  );
}
export default Text1;


/*
<p className="content-heading" id="top">
        Om <i>the</i>BiZ
      </p>

      <div className="content-text mt-4">
        <p>
          Du bär på en affärsidé? Är påtänkt, ny eller kanske redan etablerad företagare? Du undrar om Din idé 
          kan ge den <span className="strong"><i> lön som krävs </i></span> och hur lönsamheten kan 
          <span className="strong"><i> utvecklas</i></span>?               
        </p>        
        <p>
          <i>theBiZ</i> är ett effektivt verktyg för att analysera lönsamheten hos din 
          affärsidé - som den ser ut idag och samtidigt identifierar idéns förbättringspotential. Den ger professionellt 
          underlag för de <span className="strong"><i>svåra</i></span> affärsbesluten. I hårda siffror.                 
        </p>
        <ol>
          <li> Varje enskilt erbjudandes lönsamhet </li>
          <li className="mt-1"> Lönsammaste utbudsmix av dina erbjudanden</li>
        </ol>
        <p>
          Med proffs på affärsetablering från näringslivet har konceptet använts av otaliga startups 
          <span className="strong"><i> under 16 år </i></span> och bidragit till många framgångar och resultat 
          <span className="strong"><i> högt över rikssnitt.</i></span>                    
        </p>
        <p>
          Tjänsten är enkel att begripa och arbeta med. Du får <span className="strong"><i>klart besked </i></span> direkt, 
          god insikt i Din affär och helt rätt underlag för att söka extern finansiering.                    
        </p>
        <p>
          Du kan tid- och kostnadsplanera de <span className="strong"><i>åtgärder </i></span> som krävs för att realisera 
          idén i verkligheten.                    
        </p>
        <p>
          Med <i>the</i>BiZ får du både <i>verktyg</i> och <i>kompetens</i> att analysera och att höja lönsamheten
          de tre inledande etableringsåren och du ser <span className="strong"><i>live</i></span> hur 
          olika val påverkar din månadslön - <span className="strong"><i>efter</i></span> skatter och avgifter.                    
        </p>
        <p>
          Tre år är en vedertagen startsträcka för startups - men i verkligheten kan det ta längre tid än så att etablera 
          acceptabel lönsamhet. Efter År 3 kan du därför - vid behov - börja en ny treårs-analys med <i>the</i>BiZ.                     
        </p>
        <p>
          Och du - Inte en krona i något affärsprojekt innan du testat lönsamheten …!!!                     
        </p>
        <p className="lead"> 
          Massa Lycka Till                   
        </p>
        <p>
          <small><i>
            MMi AB: Idé/Produkt <br/>                
            Eduardo Olguin & Robin Asplund: Produktutveckling <br/>                 
            Peter Thörn - Extrapreneur AB: Producent
          </i></small>                      
        </p>  
           
      </div>


      <p>
        Anders & Göran - MMi AB <br/>                         
        I samverkan med Småföretagarnas Riksförbund, Extrapreneur AB och Robin Asplund.
      </p>
*/